import { io, Socket } from 'socket.io-client';

const LOG_PREFIX = '[Game WebSocket]';

function usesSameOrigin(apiUrl: string, socketPort: string): boolean {
	return apiUrl.startsWith('https://') || !socketPort || socketPort === 'same-origin' || socketPort === '443';
}

function resolveSocketUrl(): string {
	const apiUrl = (process.env.REACT_APP_API_URL ?? '').replace(/\/$/, '');
	const socketPort = (process.env.REACT_APP_SOCKET_PORT ?? '').trim();

	if (!apiUrl) {
		return '';
	}

	if (usesSameOrigin(apiUrl, socketPort)) {
		return apiUrl;
	}

	return `${apiUrl}:${socketPort}`;
}

function resolveTransports(apiUrl: string, socketPort: string): ('websocket' | 'polling')[] {
	if (usesSameOrigin(apiUrl, socketPort)) {
		return ['websocket'];
	}

	return ['polling', 'websocket'];
}

const apiUrl = (process.env.REACT_APP_API_URL ?? '').replace(/\/$/, '');
const socketPort = (process.env.REACT_APP_SOCKET_PORT ?? '').trim();
const URL = resolveSocketUrl();
const transports = resolveTransports(apiUrl, socketPort);

class SocketSingleton {
	private static instance: Socket;
	private static configLogged = false;

	private constructor() {}

	public static getInstance(): Socket {
		if (!SocketSingleton.instance) {
			if (!SocketSingleton.configLogged) {
				console.info(`${LOG_PREFIX} config`, {
					apiUrl: apiUrl || '(unset)',
					socketPort: socketPort || '(unset)',
					connectUrl: URL || '(unset)',
					socketIoPath: '/socket.io/',
					transports: transports.join(', '),
				});
				SocketSingleton.configLogged = true;
			}

			if (!URL) {
				console.error(
					`${LOG_PREFIX} missing REACT_APP_API_URL — socket.io will not connect. Set GitHub develop variables (see .github/SECRETS_AND_DEPLOYMENT.md).`
				);
			}

			SocketSingleton.instance = io(URL, {
				path: '/socket.io/',
				transports,
			});

			SocketSingleton.instance.on('connect', () => {
				console.log('Connected to Server');
			});

			SocketSingleton.instance.on('disconnect', () => {
				console.log('Disconnected from Server');
			});

			SocketSingleton.instance.on('reconnect', () => {
				console.log('Reconnected to server');
			});
		}
		return SocketSingleton.instance;
	}
}

export const socket = SocketSingleton.getInstance();
